import { analyticsManager } from "@/services/analytics/analytics-manager";

export const analyticsPlugin = {
  install(app) {
    app.config.globalProperties.$track = (tagId, options = {}) => {
      analyticsManager.trackCustom(tagId, options);
    };
  },
};
